export default "__VITE_ASSET__DsoiVY1i__"